import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FormField, Input } from "ui";

import { ParcelSizesFormValues } from "../../../financial.types";
import { parcelSizesSchema } from "../../../helpers";
import { ParcelSizesFormProps } from "./ParcelSizesForm.types";

import styles from "./ParcelSizesForm.module.scss";

const ParcelSizesForm = ({
  defaultValues,
  formId,
  onSubmit
}: ParcelSizesFormProps) => {
  const { t } = useTranslation();
  const { register, setValue, handleSubmit, formState } =
    useForm<ParcelSizesFormValues>({
      defaultValues,
      resolver: yupResolver(parcelSizesSchema)
    });

  const errorMessage = Object.values(formState.errors)
    .flatMap((field) => Object.values(field))
    .find((error) => {
      return error?.message;
    })?.message;

  return (
    <FormField errorMessage={errorMessage}>
      <form
        id={formId}
        className={styles.form}
        onSubmit={handleSubmit(onSubmit)}
      >
        <div />
        <div className={styles.form_columnTitle}>{t("Min Weight (kg)")}</div>
        <div className={styles.form_columnTitle}>{t("Max Weight (kg)")}</div>
        <div className={styles.form_columnTitle}>{t("Min Volume (cbm)")}</div>
        <div className={styles.form_columnTitle}>{t("Max Volume (cbm)")}</div>

        <div className={styles.form_rowTitle}>{t("Size")} S</div>
        <Input type="number" {...register("s.minWeight")} disabled />
        <Input
          type="number"
          {...register("s.maxWeight")}
          onChange={(e) => {
            setValue("s.maxWeight", e.target.value);
            setValue("m.minWeight", e.target.value);
          }}
          errorWithoutMessage={!!formState.errors.s?.maxWeight?.message}
        />
        <Input type="number" {...register("s.minVolume")} disabled />
        <Input
          type="number"
          {...register("s.maxVolume")}
          onChange={(e) => {
            setValue("s.maxVolume", e.target.value);
            setValue("m.minVolume", e.target.value);
          }}
          errorWithoutMessage={!!formState.errors.s?.maxVolume?.message}
        />

        <div className={styles.form_rowTitle}>{t("Size")} M</div>
        <Input
          type="number"
          {...register("m.minWeight")}
          onChange={(e) => {
            setValue("m.minWeight", e.target.value);
            setValue("s.maxWeight", e.target.value);
          }}
          errorWithoutMessage={!!formState.errors.m?.minWeight?.message}
        />
        <Input
          type="number"
          {...register("m.maxWeight")}
          onChange={(e) => {
            setValue("m.maxWeight", e.target.value);
            setValue("l.minWeight", e.target.value);
          }}
          errorWithoutMessage={!!formState.errors.m?.maxWeight?.message}
        />
        <Input
          type="number"
          {...register("m.minVolume")}
          onChange={(e) => {
            setValue("m.minVolume", e.target.value);
            setValue("s.maxVolume", e.target.value);
          }}
          errorWithoutMessage={!!formState.errors.m?.minVolume?.message}
        />
        <Input
          type="number"
          {...register("m.maxVolume")}
          onChange={(e) => {
            setValue("m.maxVolume", e.target.value);
            setValue("l.minVolume", e.target.value);
          }}
          errorWithoutMessage={!!formState.errors.m?.maxVolume?.message}
        />

        <div className={styles.form_rowTitle}>{t("Size")} L</div>
        <Input
          type="number"
          {...register("l.minWeight")}
          onChange={(e) => {
            setValue("l.minWeight", e.target.value);
            setValue("m.maxWeight", e.target.value);
          }}
          errorWithoutMessage={!!formState.errors.l?.minWeight?.message}
        />
        <Input type="number" {...register("l.maxWeight")} disabled />
        <Input
          type="number"
          {...register("l.minVolume")}
          onChange={(e) => {
            setValue("l.minVolume", e.target.value);
            setValue("m.maxVolume", e.target.value);
          }}
          errorWithoutMessage={!!formState.errors.l?.minVolume?.message}
        />
        <Input type="number" {...register("l.maxVolume")} disabled />
      </form>
    </FormField>
  );
};

export default ParcelSizesForm;
